export default {
	SET_TEAMS(state, teams) {
		state.teams = teams || [];
	},
	ADD_TEAMS(state, item) {
		state.teams.push(item);
	},
	UPDATE_TEAM(state, product) {
		const productIndex = state.teams.findIndex((p) => p.id === product.id);
		Object.assign(state.teams[productIndex], product);
	},
	REMOVE_TEAM(state, itemId) {
		const ItemIndex = state.teams.findIndex((p) => p.id === itemId);
		state.teams.splice(ItemIndex, 1);
	},
	ADD_ASSIGNED_TEAMS(state, teams) {
		state.assignedTeams = teams;
	},
	SET_ASSIGNED_TEAMS(state, items) {
		let arrayNew = state.assignedTeams.concat(
			items.filter((element) => state.assignedTeams.find((e) => e.id === element.id) === undefined)
		);
		state.assignedTeams = arrayNew;
	},
	ADD_ASSIGNED_LIST_TEAMS(state, teams) {
		let newTeamList;
		if (Array.isArray(teams)) {
			newTeamList = state.assignedTeams.concat(
				teams.filter((element) => state.assignedTeams.find((e) => e.id === element.id) === undefined)
			);
		} else {
			newTeamList = state.assignedTeams.concat(teams);
		}
		state.assignedTeams = newTeamList;
	},
	REMOVE_ASSIGNED_TEAMS(state, itemId) {
		const ItemIndex = state.assignedTeams.findIndex((p) => p.id === itemId);
		state.assignedTeams.splice(ItemIndex, 1);
	},
	CLEAN_ASSIGNED_TEAMS(state) {
		state.assignedTeams = [];
	},
};
